export const INVOICE_APP_URL = 'https://invoice.mpassist.ai';
export const HELP_URL = 'https://www.mpassist.ai/help';
export const SESSION_EXPIRED_ERROR = 'Session expired.';
export const SESSION_EXPIRED_TOAST = 'Your session has expired. Please sign in again.';
